module.exports = __webpack_public_path__ + "static/media/flexibill_arkalkulator_img.9b62562f.png";